import { API, generic } from "api"

export default class QuestionsService {
  static index = async ({ pageState, chapterId }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_QUESTIONS_INDEX_STATUS",
      stateDataKey: ["question"],
      stateErrorKey: ["questionErrors"],
      apiEndpoint: API.students.questions.index,
      apiUrlReplacements: { chapterId },
      apiData: {},
      errorMessage: "Question could not be fetched"
    })
  }

  static show = async ({
    pageState,
    chapterId,
    questionId,
    questionnaireId
  }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_QUESTIONS_SHOW_STATUS",
      stateDataKey: [
        "question",
        "chapter",
        "questionnaire",
        "questionnaire_attempt"
      ],
      stateErrorKey: [
        "questionErrors",
        "chapterErrors",
        "questionnaireErrors",
        "questionnaire_attemptErrors"
      ],
      apiEndpoint: API.students.questions.show,
      apiUrlReplacements: { chapterId, questionId, questionnaireId },
      apiData: {},
      errorMessage: "Question could not be fetched"
    })
  }

  static answer = async ({
    pageState,
    questionId,
    chapterId,
    questionnaireId,
    selectedOptionIndices
  }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_QUESTIONS_ANSWER_STATUS",
      stateDataKey: ["questionnaireAttempt"],
      stateErrorKey: ["questionnaireAttemptErrors"],
      apiEndpoint: API.students.questions.answer,
      apiUrlReplacements: { chapterId, questionId, questionnaireId },
      apiData: { selected_option_index: selectedOptionIndices },
      errorMessage: "Answer could not be saved"
    })
  }
}
